export default {
  title: 'ХРИСТИАНСКОЕ ВЕРОИСПОВЕДАНИЕ',
  sections: [
    [
      {
        title: 'БИБЛИЯ -',
        description: `слово и мысль Бога она, словами людей изречена, Евангелием обобщена.
Библия совершенна, и включает в себя она все нужды и чувства человека.`,
      },
      {
        title: 'БОГ',
        description: `есть Дух и самосущий: существует Сам по Себе; не сотворённый,
Он триединство Отца, Сына и Святого Духа.
Он в единении, един и единственный, и нет другого бога, кроме Него.
Совершен Он в любви, в святости, могуществе,
знании, мудрости. Он вечно Тот же, неизменный.
Он создал Небо и Землю и все существа, которые в них.
И все они живут Им, кончину находят тоже Им.
Он вездесущий, всë творение блюдётся Им.
С каждой сотворённой личностью Он, и в каждом человеке, избравшем Его.`,
      },
      {
        title: 'ЧЕЛОВЕК -',
        description: `потомство Адама, рождённый от Евы, рукою Божьей сотворённые оба,
По образу и подобию Бога, чтобы властвовал человек на земле.
Однако Адам нарушил заповедь, стал грешником, так как совершил грех.
Беззаконие он принял от дьявола, и в нëм изменилась природа святая.
И он отступил от закона жизни, и потому лишился славы Божьей.
Закон смерти вошёл в него, ко греху устремились желанья его.
Природу греховную приобрёл он, к беззаконию стремится он.
И осквернённая эта природа стала наследством человеческого рода.`,
      },
      {
        title: 'ЗАКОН БОЖИЙ -',
        description: `свят и совершен, намного выше он законов всех.
Он право и грех выявляет и людей ко Христу направляет.`,
      },
    ],
    [
      {
        title: 'ИИСУС ХРИСТОС -',
        description: `Один из Святого Божьего Триединства,
Единородный Сын, естеством Бога.
Он от Бога родился как Бог, а не как сотворённый.
Он также родился от девы, силой Божьей, как Сын Человеческий.
Человеческую плоть и природу обрëл, и в этой плоти поклоняем был Он.
Искушаем был, как мы, но не согрешил. И, как святой Агнец, за нас распят Он был.
Он своею кровью грехи наши искупил, смерть и грех - в плоти своей осудил.
Крестной смертью Он даровал спасенье, воскрес Иисус в том же теле.
Отданы Ему Небо и Земля, вознесясь на небо, воссел одесную Отца.
Иисус - Спаситель этого мира, чтобы верующий спасся от дьявола.
Иисус вернётся славою Отца и святым усопшим воскресенье даст.
И вместе с ними святые все - от земли восхитятся к Господу Христу.
В конце времён Господь наш Иисус выявит дела человеческие.
Праведники пойдут в жизнь вечную, а нечестивые – в вечные муки.
И будет царствовать наш Иисус Господь, и не будет конца владычеству Его.
Бог сотрёт слезу, и смерти не будет, престол Господа - наши очи увидят.`,
      },
      {
        title: 'СВЯТОЙ ДУХ -',
        description: `Один из Святого Божьего Триединства – вечно не отделимый.
Равный Богу и в том же положении всегда: совершенно святой, не изменяется никогда.
И Господь, Иисус Христос, спасённого Им человека крестит в Духе Святом.`,
      },
      {
        title: 'ЦЕРКОВЬ -',
        description: `группа людей, обращённая к Иисусу Христу и освящённая,
Чтобы великой цели достигли они: стали подобны Богу – Его святому образу.
Чтобы во всех веках свидетельствовать об Иисусе и людям проповедовать Евангелие.
Верующего водой крестить и Вечерю Господню проводить.`,
      },
    ],
  ],
};
